import { Link } from "react-router-dom";
import { siteInfo, categories } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-700">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-7 h-7 flex items-center justify-center">
                <i className="ri-fire-fill text-primary-500 text-xl"></i>
              </div>
              <span className="font-heading text-lg font-bold text-foreground-50 tracking-wider">
                {siteInfo.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed mb-3">
              {siteInfo.tagline}
            </p>
            <p className="text-sm text-foreground-500 leading-relaxed">
              每日不间断追踪网络热点事件，为吃瓜群众提供最快、最全、最真实的娱乐八卦资讯。
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              热门分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                >
                  APP下载
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-400 hover:text-primary-400 transition-colors duration-200"
                >
                  投稿爆料
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-4">
              关注我们
            </h4>
            <div className="flex items-center gap-4 mb-4">
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 hover:bg-primary-500 rounded-full transition-colors duration-200 cursor-pointer">
                <i className="ri-weibo-line text-foreground-300 hover:text-foreground-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 hover:bg-primary-500 rounded-full transition-colors duration-200 cursor-pointer">
                <i className="ri-wechat-line text-foreground-300 hover:text-foreground-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 hover:bg-primary-500 rounded-full transition-colors duration-200 cursor-pointer">
                <i className="ri-telegram-line text-foreground-300 hover:text-foreground-50 text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center bg-background-800 hover:bg-primary-500 rounded-full transition-colors duration-200 cursor-pointer">
                <i className="ri-twitter-x-line text-foreground-300 hover:text-foreground-50 text-base"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-500 mb-1">
              联系邮箱：{siteInfo.email}
            </p>
            <p className="text-sm text-foreground-500">
              微博：{siteInfo.weibo}
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700">
        <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} {siteInfo.name} 版权所有 |
            本站内容仅供娱乐参考，请理性吃瓜
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-600">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">
              免责声明
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}